import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';
import { PagedResponseInterface } from 'src/app/shared/classes/paged-response.interface';
import { SentEmailLogListItemResponse } from './definitions/sent-email-log-response.interface';
import { createQueryParams } from './sent-email-logs-get-query-params-factory';
import { SentEmailLogGetQueryParamsInterface } from './definitions/sent-email-log-get-query-params.interface';

@Injectable()
export class TaskGetSentEmailLogsService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public getSentEmailLogs(taskId: string, paramsObj: SentEmailLogGetQueryParamsInterface): Observable<PagedResponseInterface<SentEmailLogListItemResponse>> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/sent-email-logs`;

    const params: HttpParams = createQueryParams(paramsObj);

    return this.client.get<PagedResponseInterface<SentEmailLogListItemResponse>>(url, { params }).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
